import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { SHIPPING_LABEL_COUNTRIES } from '@ivario-arc/shared/src/constants';
import { CountryEnum } from '@ivario-arc/shared/src/enums';
import ShipmentInstructions from '@components/atoms/ShippmentInstructions';
import {
  ButtonType,
  ConfigDto,
  SampleDetailsDto,
  SampleStatus,
} from '@src/types/types';
import { Button } from '@components/atoms/Button';
import { StyledMarkdown } from '@components/atoms/StyledMarkdown';
import { Image } from '@components/atoms/Image';

interface SampleInstructionsProps {
  imageSrc?: string;
  sample: SampleDetailsDto;
  config: ConfigDto;
}

export const SampleInstructions: React.FC<SampleInstructionsProps> = ({
  sample,
  config,
}) => {
  const { t } = useTranslation('component', { keyPrefix: 'sampleDetails' });

  if (!config || !sample) {
    return null;
  }
  let statusText: string | undefined;
  if (sample.status === SampleStatus.ACTIVATED) {
    statusText = config.instructionActivated;
  } else if (sample.status === SampleStatus.SHIPPED) {
    statusText = config.instructionShipped;
  } else if (sample.status === SampleStatus.ARRIVED_IN_LAB) {
    statusText = config.instructionArrived;
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
      <div>
        {config.statusPageInstructionImage ? (
          <Image
            image={config.statusPageInstructionImage}
            alt={t('instructions.image')}
            className="rounded-xl w-full"
            sizes="(max-width: 768px) 100vw, 50vw"
            lazy={false}
          />
        ) : (
          <img
            src="/pictures/water-sample.png"
            alt={t('instructions.image')}
            className="rounded-xl w-full"
          />
        )}
      </div>
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-bold text-ivarioBlue mb-4">
            {t('instructions.nextSteps')}
          </h2>
          {SHIPPING_LABEL_COUNTRIES.includes(
            sample.shippingCountry as CountryEnum,
          ) && <StyledMarkdown markdown={statusText} />}
        </div>
        {sample.status === SampleStatus.ACTIVATED ? (
          <ShipmentInstructions sample={sample} background="grey" />
        ) : (
          <Link to={sample.trackingURL!} target="_blank">
            <Button
              label={t('instructions.trackingLink')}
              disabled={!sample.trackingURL}
              buttonType={ButtonType.PRIMARY}
            />
          </Link>
        )}
      </div>
    </div>
  );
};
